/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import Keyboard from '../components/keyboard/Keyboard';
import {setField} from '../../common/lib/redux-fields/actions';
import {changeDeviceSettings} from '../../common/device/actions';
import {checkDomain} from '../../common/chooseDomain/actions';
import {removeErrors, setOfflineError} from '../../common/app/actions';
import {setFocusId} from '../../common/components/keyboard/actions';
import {isEnv} from '../../common/lib/util';
import {fullLoadingShow, fullLoadingHide} from '../../common/components/loadings/actions';
import QuitButton from '../components/buttons/QuitButton';
import LanguageSwitcher from '../components/intl/LanguageSwitcher';

class ChooseDomain extends React.Component {

    state: State = {
        domainError: false
    };

    static propTypes = {
        msg: React.PropTypes.object,
        setOfflineError: React.PropTypes.func,
        fullLoadingShow: React.PropTypes.func,
        fullLoadingHide: React.PropTypes.func,
        setField: React.PropTypes.func,
        setFocusId: React.PropTypes.func,
        changeDeviceSettings: React.PropTypes.func,
        removeErrors: React.PropTypes.func,
        checkDomain: React.PropTypes.func,
        fields: React.PropTypes.object,
        error: React.PropTypes.object,
        organizationDomain: React.PropTypes.string,
        deviceId: React.PropTypes.number,
        formDisabled: React.PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.onChangeForm = this.onChangeForm.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onQuit = this.onQuit.bind(this);
        this.redirectToOrg = this.redirectToOrg.bind(this);
    }

    onChangeForm({target: {name, value}}) {
        const {setField} = this.props;
        setField(name, value);
    }

    redirectToOrg(domain) {
        localStorage.setItem('domain', domain)
        setTimeout(function(){
            location.href = '/';
        }, 500);
    }

    onFormSubmit(e) {
        e.preventDefault();
        const {checkDomain, fields, msg, setOfflineError, changeDeviceSettings} = this.props;
        this.setState({domainError: false});

        const domain = fields.getIn('domain').replace(/\s/g, '');
        checkDomain(domain).payload.promise
            .then(() => {
                this.redirectToOrg(domain);
            })
            .catch((res) => {
                if (!res.status) {
                    setOfflineError(msg.domain.serverUnavailable);
                } else {
                    this.setState({domainError: true});
                }
            });
    }

    onQuit(e) {
      if (isEnv(['android_app', 'electron'])) {
          if (typeof window.parent.Ocellot !== 'undefined') {
              window.parent.Ocellot.quit();
          } else {
              window.parent.ocellotQuit();
          }
      }
    }

    componentWillMount() {
        const {setField, removeErrors, fullLoadingShow} = this.props;
        fullLoadingShow();
        removeErrors();
        setField('domain', '');
    }

    componentDidMount() {
        const {organizationDomain, changeDeviceSettings, fullLoadingHide} = this.props;

        if (typeof location !== 'undefined' && location.pathname === '/choose-domain/1') {
            localStorage.removeItem('domain');
            changeDeviceSettings('organizationDomain', '');
            fullLoadingHide();
        } else if (!!organizationDomain) {
            this.redirectToOrg(organizationDomain);
        } else {
            fullLoadingHide();
        }
    }

    componentWillUnmount() {
        const {removeErrors} = this.props;
        removeErrors();
    }

    render() {
        const {fields, formDisabled, error, setFocusId, msg} = this.props;
        const {domainError} = this.state;

        return (
            <div id="login-page" className="pageLogin keyboardPanel">
                <h1 className="pageLogin-logo">{msg.global.appName}</h1>
                {isEnv(['android_app', 'electron']) &&
                  <div className="pageLogin-quit">
                    <button className="boxBtn color-red" onClick={this.onQuit}>
                      <QuitButton/>
                    </button>
                  </div>
                }
                <LanguageSwitcher/>
                <div className="keyboardPanel-panel">
                    <div className="form">
                        <form className="formWithKeyboard"
                              autoComplete="off"
                              id="formWithKeyboard"
                              onChange={e => this.onChangeForm(e)}
                              onSubmit={e => this.onFormSubmit(e)}>
                            <fieldset disabled={formDisabled}>
                                <div className="form-row">
                                    <label htmlFor="login" className="form-label">{msg.domain.orgCode}</label>
                                    <input autoFocus
                                           autoComplete="off"
                                           onFocus={() => setFocusId('domain')}
                                           type="text"
                                           className="form-input"
                                           name="domain"
                                           tabIndex="1"
                                           value={fields.getIn('domain')}
                                           id="domain"/>
                                </div>
                                {!!error &&
                                <div className="form-errors">
                                  <div className="errors">
                                      <ul>
                                          {error.map((err, i) =>
                                              <li key={`error-key-${i}`}>{err}</li>
                                          )}
                                      </ul>
                                  </div>
                                </div>
                                }

                                {domainError &&
                                  <div className="form-errors">
                                      <div className="errors">
                                          <ul>
                                              <li>{msg.domain.codeNotExists}</li>
                                          </ul>
                                      </div>
                                  </div>
                                }
                                <div className="form-btns">
                                    <button type="submit" className="btn btn-green btn-block">{msg.domain.continue}</button>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
                <div className="keyboardPanel-keyboard">
                  {isEnv(['electron', 'web_desktop']) &&
                      <Keyboard />
                  }
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    fields: state.fields,
    formDisabled: state.login.get('formDisabled'),
    deviceId: state.device.get('id'),
    organizationDomain: state.device.get('organizationDomain'),
    error: state.app.get('error')
}), {
    setField, checkDomain, removeErrors, setFocusId, setOfflineError, changeDeviceSettings, fullLoadingShow,
    fullLoadingHide
})(ChooseDomain);



// WEBPACK FOOTER //
// ./src/browser/chooseDomain/ChooseDomain.js